import React from 'react';

import * as api from './API';
import { getMicroContentList } from 'Services/Microexperiences';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { TagsContextProvider } from 'Modules/Components/TagsContext';


const initalState = {
    microContentList: [],
    nudgeList: [],
    //    lookups : {Status:[], Type:[], Effort:[], RequiredItems:[]},
    users: [],
    sparkList: [],
    publicDates: [],
    updateData: () => {},
};

export const MicroExperienceManagerContext = React.createContext(initalState);

function MicroExperiencesReducer(state, action) {
    switch (action.type) {
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
}

export function MicroExperienceManagerProvider(props) {
    console.log('MicroExperienceManagerProvider Render');
    const [state, dispatch] = React.useReducer(MicroExperiencesReducer, initalState);
    // NOTE: you *might* need to memoize this value
    // Learn more in http://kcd.im/optimize-context
    const [users, setUsers] = React.useState([]);
    const [sparkList, setSparkList] = React.useState([]);
    const [microContentList, setMicroContentList] = React.useState([]);
    const [publicDates, setPublicDates] = React.useState([]);
    const [isLoading, setisLoading] = React.useState(false);

        
    
    React.useEffect(() => {
        console.log('MEX : context init');

        async function getData() {
            setisLoading(true)
            const users = await api.getUsers();
            setUsers(users);

            const sparks = await api.getSparks();
            setSparkList(sparks);

            const mex = await getMicroContentList();
            setMicroContentList(mex);

            const pub = await api.getPublicDates();
            setPublicDates(pub);

            setisLoading(false);
            console.log('MEX : Context done');
        }

        getData();
    }, []);

    const value = {
        state,
        dispatch,
        users,
        sparkList,
        microContentList,
        publicDates,
    };
    return (
        <MicroExperienceManagerContext.Provider value={value} {...props}>
            <TagsContextProvider>
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading} >
                    <CircularProgress color="inherit" />
                </Backdrop>
                {props.children}
            </TagsContextProvider>

        </MicroExperienceManagerContext.Provider>
    );
}
